import React, { useEffect } from "react";

import { useTranslation } from "@impero-com/common/utils/i18n";
import { Tooltip } from "@impero-com/ui";
import { Checkbox } from "antd";
import moment from "moment-timezone";
import { Control, useController, useWatch } from "react-hook-form";

import { ControlViewFormSchema } from "../formSchema";

import * as theme from "./SendImmediatelyCheckbox.theme.css";

interface SendImmediatelyCheckboxProps {
    control: Control<ControlViewFormSchema>;
    disabled?: boolean;
    className?: string;
}

export const SendImmediatelyCheckbox: React.FC<
    SendImmediatelyCheckboxProps
> = ({ control, disabled, className }) => {
    const { t } = useTranslation();
    const { field } = useController({
        control,
        name: "sendImmediately",
        disabled,
    });
    const startDate = useWatch({ control, name: "scheduling.startDate" });
    const dueTime = useWatch({ control, name: "scheduling.dueTime" });
    const timezoneName = useWatch({ control, name: "scheduling.timezoneName" });

    const dueDateTime = moment(startDate).tz(timezoneName).set({
        hours: dueTime.getHours(),
        minutes: dueTime.getMinutes(),
    });
    const isPastDueDateTime = moment().tz(timezoneName).isAfter(dueDateTime);

    useEffect(() => {
        if (isPastDueDateTime) {
            field.onChange(false);
        }
    }, [isPastDueDateTime]); // eslint-disable-line react-hooks/exhaustive-deps

    const checkbox = (
        <Checkbox
            checked={field.value}
            onChange={(e) => field.onChange(e.target.checked)}
            disabled={isPastDueDateTime || disabled}
        >
            <div className={className}>
                {t("CreateControl_Recurrence_SendImmediatelyCheckboxText")}
            </div>
        </Checkbox>
    );

    if (isPastDueDateTime) {
        return (
            <div className={theme.sendImmediatelyTooltipWrapper}>
                <Tooltip
                    title={t("Control_SendImmediately_Past_DueDate_Error")}
                    placement="top"
                >
                    <span>{checkbox}</span>
                </Tooltip>
            </div>
        );
    }

    return checkbox;
};
